import { Currency } from "@types";
import { getMemberSettings } from "@utils/member-settings";
import {
  FundingMethodDepositMethod,
  FundingMethodKey,
  FundingMethodModel,
  FundingMethodStatus,
  FundingMethodType,
  FundingTxPayDataType,
  bnOrZero,
} from "kz-ui-sdk";

export const MINT_METHOD: FundingMethodModel = {
  createdAt: undefined,
  deletedAt: undefined,
  max: bnOrZero(10_000_000_000),
  min: bnOrZero(100),
  updatedAt: undefined,
  accountId: null,
  banner: {
    url: "/images/mint-logo.png",
    mimeType: "",
  },
  bannerId: "",
  creditReqAmount: true,
  currency: "",
  disabled: false,
  fundingProviderId: "",
  id: "",
  isDefault: false,
  key: FundingMethodKey.MintDeposit,
  method: FundingMethodDepositMethod.QrCode,
  name: "Mint Deposit",
  proofRequired: false,
  skipAmountInput: false,
  sort: 0,
  status: FundingMethodStatus.Active,
  type: FundingMethodType.Deposit,
  returnType: FundingTxPayDataType.REDIRECT,
};

// Minimal AUTO_FAST_METHOD definition - only includes fields needed for UI and BE identification
export const AUTO_FAST_METHOD: Partial<FundingMethodModel> = {
  id: "auto-fast",
  name: "auto (fast)",
  isDefault: true,
  sort: -1, // Ensure it appears first
  status: FundingMethodStatus.Active,
  currency: getMemberSettings?.()?.currency as Currency,
  // TODO: Add any additional fields required by BE for auto-switch mode identification
};
